module.exports = __webpack_public_path__ + "img/2020-gongan.d0289dc0.png";